/* unplugin-vue-components disabled */import { render } from "./NullPage.vue?vue&type=template&id=5f4b3f1a"
const script = {}

import exportComponent from "/home/runner/work/gh-docs-frontend/gh-docs-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__